// extracted by mini-css-extract-plugin
export default {"root":"LicenseCard_root__Ya9bV","displayHeader":"LicenseCard_displayHeader__bCjeA"};